<template>
  <b-modal
    :id="'bookModal_' + modalid"
    centered
    size="lg"
    headerClass="p-2 border-bottom-0"
    footerClass="p-2 border-top-0"
    hide-footer
  >
    <b-row class="pb-5 m-0">
      <b-col class="col-12 col-md-auto text-center">
        <div style="position: relative;">
          <transition name="fade">
            <div
              v-if="onFavs"
              style="
      position: absolute;
      z-index: 10;
      right: -2px;
      top: 50px;
      width: 35%;
      filter: drop-shadow(2px 4px .25rem rgba(0,0,0,.5));"
            >
              <img src="@/assets/favorite.svg" />
            </div>
          </transition>
          <img :src="bookData.imgCover" style="max-width: 280px;" />
          <img
          v-if="bookData.promo"
          :src="$store.state.user.siteData.location +
            'repository/promos/' + bookData.promo" 
          style="
            position: absolute;
            top: 0px;
            left: 0px;
            max-width: 280px;"      
          />
        </div>
        <div>
          <b-button
            class="m-1"
            style="font-size: .85rem;"
            variant="light"
            v-if="!onFavs"
            @click="addToFav()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="heart"
              class="svg-inline--fa fa-heart fa-w-16"
              role="img"
              viewBox="0 0 512 512"
              width="1em"
              height="1em"
            >
              <path
                fill="currentColor"
                d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
              />
            </svg>
            Agregar a favoritos
          </b-button>
          <b-button
            class="m-1"
            style="font-size: .85rem;"
            v-if="onFavs"
            @click="removeFromFav()"
          >
            <font-awesome-icon icon="heart" class="mr-1" />Quitar de favoritos
          </b-button>
          <b-button
            class="m-1 flex-fill"
            v-b-tooltip.hover
            title="Sin stock"
            style="border-radius: 0.7rem;background: rgb(192 205 217);border: #6c757d;"
            v-if="bookData.bookStock <= 0"
          >
            
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
            >
              &times;
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="1.2rem"
              height="1.2rem"
            >
              <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
              <path
                id="svg_2"
                d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
              />
            </svg>
            
          </b-button>
          <b-button
            class="m-1 flex-fill px-3"
            @click="addItem()"
            v-b-tooltip.hover
            title="Agregar al carrito"
            style="border-radius: .7rem;"
            v-else-if="onCart === 0"
          >
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
            >
              +
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="1.2rem"
              height="1.2rem"
            >
              <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
              <path
                id="svg_2"
                d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
              />
            </svg>
          </b-button>
          <b-button
            class="m-1 flex-fill cartActive px-3"
            @click="addItem()"
            v-b-tooltip.hover
            title="Agregar al carrito"
            style="border-radius: .7rem; background: #e8661a; border:none;"
            v-else
          >
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
            >
              {{ onCart }}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="1.2rem"
              height="1.2rem"
            >
              <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
              <path
                id="svg_2"
                d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
              />
            </svg>
          </b-button>
        </div>
      </b-col>
      <b-col style="padding-right: 30px;">
        <div
          style="font-weight: bolder; font-family: 'Poppins', sans-serif; font-size: x-large;"
        >
          {{ bookData.bookTitle }}
        </div>
        <div
          style="font-family: 'Poppins', sans-serif; font-size: large; line-height: 1.5rem;"
        >
          {{ bookData.bookSubtitle }}
        </div>
        <div
          class="py-2 text-muted"
          style="font-family: 'Poppins', sans-serif;"
        >
          <span v-html="bookData.bookDesc"></span>
        </div>
        <div
          style="font-size: small; overflow-y: auto; max-height: 11rem; margin-bottom: 1rem;"
        >
          <span v-html="bookData.bookResume"></span>
        </div>
        <div
          style="font-weight: bolder; font-family: 'Poppins', sans-serif; font-size: x-large; color: #e8661a;"
        >
          <span
            v-if="bookData.bookPrice != bookData.regularCost"
            style="color: rgb(179, 179, 179); text-decoration: line-through;"
            >${{ bookData.regularCost }}</span
          >
          ${{ bookData.bookPrice }}
          <span v-if="bookData.bookStock <= 0" class="text-danger mt-3" style="font-size: small; font-weight: bold;">
              Sin Stock
          </span>
        </div>
        <div class="text-right pr-2 mt-2">
          <b-link class="text-dark" v-if="!escombo" :to="'/detalles/' + bookData.bookId">
            Ver más detalles
            <b-icon icon="chevron-right" />
          </b-link>
          <b-link class="text-dark" v-else :to="'/combo/' + bookData.bookId">
            Ver más detalles
            <b-icon icon="chevron-right" />
          </b-link>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import { mapActions } from "vuex";

export default {
  props: {
    bookData: Object,
    modalid: Number,
    escombo: Boolean
  },
  data: function() {
    return {};
  },
  computed: {
    onCart: function() {
      if (this.escombo) {
        return this.$store.getters.getItemByType({ id: this.bookData.bookId, type: 5 });
      } else {
        return this.$store.getters.getItemById(this.bookData.bookId);
      }
    },
    onFavs: function() {
      let favBookIndex = 0;
      if (this.escombo) {
        favBookIndex = this.$store.getters.getFavItemByType({ id: this.bookData.bookId, type: 5 });
      } else {
        favBookIndex = this.$store.getters.getFavItemById(this.bookData.bookId);
      }
      if (favBookIndex === 0) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    addItem: function() {
      if (this.escombo) {
        this.addCartItem({id: this.bookData.bookId, type: 5});
      } else {
        this.addCartItem(this.bookData.bookId);
      }
    },
    addToFav: function() {
      if (this.escombo) {
        this.addFavItem({id: this.bookData.bookId, type: 5});
      } else {
        this.addFavItem(this.bookData.bookId);
      }
    },
    removeFromFav: function() {
      if (this.escombo) {
        this.removeFavItem({id: this.bookData.bookId, type: 5});
      } else {
        this.removeFavItem(this.bookData.bookId);
      }
    },
    showModal: function() {
      this.$parent.showModal(this.bookData.bookId);
    },
    ...mapActions(["addCartItem", "addFavItem", "removeFavItem"])
  }
};
</script>
